import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '../types';
import { PaymentState } from './types';
import { PaymentError } from '@/api/Cart/cart.interfaces';
import { LoanStatus, PaymentOption } from '@/api/LeaBank/leaBank.interfaces';
import { ApplicantForm } from '@/api/LeaBank/leaBank.interfaces.applicant';

const initialState: PaymentState = {
    error: null,
    loan: {
        pricing: null,
        type: null,
        status: null,
        form: {} as ApplicantForm,
    },
};

const state: PaymentState = {
    ...initialState,
};

const getters: GetterTree<PaymentState, RootState> = {
    getError(state): PaymentError | null {
        return state.error;
    },
    getLoanPricing(state): PaymentOption[] | null {
        return state.loan.pricing;
    },
    getLoanStatus(state): LoanStatus | null {
        return state.loan.status;
    },
    getLoanForm(state): ApplicantForm {
        return state.loan.form;
    },
};

const actions: ActionTree<PaymentState, RootState> = {
    setError({ state, commit }, payload) {
        commit('setState', {
            ...state,
            error: payload,
        });
    },
    setLoanPricing({ state, commit }, payload) {
        commit('setState', {
            ...state,
            loan: {
                ...state.loan,
                pricing: payload,
            },
        });
    },
    setLoanStatus({ state, commit }, payload) {
        commit('setState', {
            ...state,
            loan: {
                ...state.loan,
                status: payload,
            },
        });
    },
    setLoanForm({ state, commit }, payload) {
        commit('setState', {
            ...state,
            loan: {
                ...state.loan,
                form: payload,
            },
        });
    },
};

const mutations: MutationTree<PaymentState> = {
    setState(state, payload) {
        Object.assign(state, payload);
    },
};

export const payment: Module<PaymentState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
